module.exports = __webpack_public_path__ + "img/package-gift-gold.84558b47.svg";